// extracted by mini-css-extract-plugin
module.exports = {"loginFormWrapper":"forgot-password_loginFormWrapper__MR5We","form":"forgot-password_form__3MxHX"};